import React, { createContext, useEffect, useRef, useState } from "react";
import { createTValue, getCookie } from "@utils/utils";
import { exitModalTagging } from "@utils/utils.gtm";
import { globalHistory } from "@reach/router";

const defaultState = {};

const AppContext = createContext(defaultState);

const AppProvider = ({ children }) => {
  const headerRef = useRef(null);
  const stickyCtaRef = useRef(null);
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [scrollDirection, setScrollDirection] = useState("up");
  const [showSweatCheck, setShowSweatCheck] = useState(false);
  const [heroVersion, setHeroVersion] = useState('a');

  const setHeaderVisible = (visible) => {
    setIsHeaderVisible(visible);
  };

  const updateScrollDirection = (direction) => {
    setScrollDirection(direction);
  };

  useEffect(() => {
    const storeUrlParamsInCookie = () => {

      const cookieValue = getCookie("t");
      const searchParams = new URLSearchParams(window.location.search);

      if (searchParams.toString() || !cookieValue) {
        const urlParameters = createTValue(searchParams);
        document.cookie = `t=${urlParameters}; path=/; SameSite=Lax`;
      }
    };

    storeUrlParamsInCookie();

  }, []);

  // State for ExitModal
  const [showExitModal, setShowExitModal] = useState(false);
  const [exitUrl, setExitUrl] = useState("");

  // Functions to control ExitModal
  const openExitModal = (url) => {
    setExitUrl(url);
    setTimeout(() => {
      setShowExitModal(true);
    }, 100);
  };

  const closeExitModal = (linkText) => {
    setShowExitModal(false);
    const eventAction = typeof linkText === "string" ? linkText : "Close";
    exitModalTagging(eventAction, exitUrl);
    setExitUrl("");
  };

  // Add this useEffect to handle route changes
  useEffect(() => {
    return globalHistory.listen(({ action }) => {
      if (action === "PUSH") {
        setShowSweatCheck(false);
      }
    });
  }, []);

  const store = {
    headerRef,
    stickyCtaRef,
    showExitModal,
    exitUrl,
    openExitModal,
    closeExitModal,
    isHeaderVisible,
    setHeaderVisible,
    scrollDirection,
    updateScrollDirection,
    showSweatCheck,
    setShowSweatCheck,
    heroVersion,
    setHeroVersion,
  };

  return <AppContext.Provider value={store}>{children}</AppContext.Provider>;
};

export default AppContext;
export { AppProvider };
